import React from "react";
import { Role } from "@/api/roles";
import {
  MultipleSelectDataGrid,
  DataGridColumn,
} from "@/ui-controls/DataGrid";

interface Props {
  appRoles: Role[];
  onSelectionChanged: (selectedList: Role[]) => any;
}

const RoleSelectDetailList = (props: Props) => {
  const columns: DataGridColumn[] = [
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
  ];

  return (
    <>
      <MultipleSelectDataGrid
        items={props.appRoles}
        columns={columns}
        onSelectionChanged={props.onSelectionChanged}
      />
    </>
  );
};

export default RoleSelectDetailList;
